<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="1.25" y1="1.75" x2="12.75" y2="1.75" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
<line x1="1.25" y1="2.25" x2="1.25" y2="12.75" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
</svg>
